/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BooleanInt32NullableKeyValuePair,
    BooleanInt32NullableKeyValuePairFromJSON,
    BooleanInt32NullableKeyValuePairFromJSONTyped,
    BooleanInt32NullableKeyValuePairToJSON,
    BooleanInt64NullableKeyValuePair,
    BooleanInt64NullableKeyValuePairFromJSON,
    BooleanInt64NullableKeyValuePairFromJSONTyped,
    BooleanInt64NullableKeyValuePairToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleBulkUpdateData
 */
export interface SearchSubRuleBulkUpdateData {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSubRuleBulkUpdateData
     */
    ruleIds?: Array<string> | null;
    /**
     * 
     * @type {BooleanInt64NullableKeyValuePair}
     * @memberof SearchSubRuleBulkUpdateData
     */
    maxPriceSolutions?: BooleanInt64NullableKeyValuePair;
    /**
     * 
     * @type {BooleanInt64NullableKeyValuePair}
     * @memberof SearchSubRuleBulkUpdateData
     */
    maxPricePoints?: BooleanInt64NullableKeyValuePair;
    /**
     * 
     * @type {BooleanInt32NullableKeyValuePair}
     * @memberof SearchSubRuleBulkUpdateData
     */
    maxConnectionTimeHours?: BooleanInt32NullableKeyValuePair;
    /**
     * 
     * @type {BooleanInt32NullableKeyValuePair}
     * @memberof SearchSubRuleBulkUpdateData
     */
    maxConnectionTimeMinutes?: BooleanInt32NullableKeyValuePair;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    excludeBaglessFares?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    excludeDoubleConnections?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    directFlightsOnly?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    restrictMultiAirportConnections?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    restrictMultiSectorSearch?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    excludeUpSell?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleBulkUpdateData
     */
    disabled?: boolean | null;
}

export function SearchSubRuleBulkUpdateDataFromJSON(json: any): SearchSubRuleBulkUpdateData {
    return SearchSubRuleBulkUpdateDataFromJSONTyped(json, false);
}

export function SearchSubRuleBulkUpdateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleBulkUpdateData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ruleIds': !exists(json, 'ruleIds') ? undefined : json['ruleIds'],
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : BooleanInt64NullableKeyValuePairFromJSON(json['maxPriceSolutions']),
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : BooleanInt64NullableKeyValuePairFromJSON(json['maxPricePoints']),
        'maxConnectionTimeHours': !exists(json, 'maxConnectionTimeHours') ? undefined : BooleanInt32NullableKeyValuePairFromJSON(json['maxConnectionTimeHours']),
        'maxConnectionTimeMinutes': !exists(json, 'maxConnectionTimeMinutes') ? undefined : BooleanInt32NullableKeyValuePairFromJSON(json['maxConnectionTimeMinutes']),
        'excludeBaglessFares': !exists(json, 'excludeBaglessFares') ? undefined : json['excludeBaglessFares'],
        'excludeDoubleConnections': !exists(json, 'excludeDoubleConnections') ? undefined : json['excludeDoubleConnections'],
        'directFlightsOnly': !exists(json, 'directFlightsOnly') ? undefined : json['directFlightsOnly'],
        'restrictMultiAirportConnections': !exists(json, 'restrictMultiAirportConnections') ? undefined : json['restrictMultiAirportConnections'],
        'restrictMultiSectorSearch': !exists(json, 'restrictMultiSectorSearch') ? undefined : json['restrictMultiSectorSearch'],
        'excludeUpSell': !exists(json, 'excludeUpSell') ? undefined : json['excludeUpSell'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SearchSubRuleBulkUpdateDataToJSON(value?: SearchSubRuleBulkUpdateData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ruleIds': value.ruleIds,
        'maxPriceSolutions': BooleanInt64NullableKeyValuePairToJSON(value.maxPriceSolutions),
        'maxPricePoints': BooleanInt64NullableKeyValuePairToJSON(value.maxPricePoints),
        'maxConnectionTimeHours': BooleanInt32NullableKeyValuePairToJSON(value.maxConnectionTimeHours),
        'maxConnectionTimeMinutes': BooleanInt32NullableKeyValuePairToJSON(value.maxConnectionTimeMinutes),
        'excludeBaglessFares': value.excludeBaglessFares,
        'excludeDoubleConnections': value.excludeDoubleConnections,
        'directFlightsOnly': value.directFlightsOnly,
        'restrictMultiAirportConnections': value.restrictMultiAirportConnections,
        'restrictMultiSectorSearch': value.restrictMultiSectorSearch,
        'excludeUpSell': value.excludeUpSell,
        'disabled': value.disabled,
    };
}


